import stackOverflow from '../images/stackOver.png';
import github from '../images/github.png';
import linkedin from '../images/linkedin.png';
import gmail from '../images/gmail.png';

const links = [
  {
    id: 1,
    href: "https://stackoverflow.com/users/21267050/reinaldo-pereira-dos-santos",
    alt: "StackOverFlow",
    image: stackOverflow,
  },
  {
    id: 2,
    href: "https://www.linkedin.com/in/reinaldo-pereira/",
    alt: "LinkedIn",
    image: linkedin,
  },
  {
    id: 3,
    href: "https://github.com/reinaldoper",
    alt: "GitHub",
    image: github,
  },
  {
    id: 4,
    href: "mailto:reinaldoper83@gmail.com?subject=Hello%20again",
    alt: "Gmail",
    image: gmail,
  }
]

export default links;